import Vue from 'vue'
import Vuex from 'vuex'
import { generateNonce, requestLogin } from '@/api/authencation'
import { requestUserProfile } from '@/api/member'
import { signMessage } from '@/web3/index'
import { setToken, getToken, removeToken } from '@/utils/auth'
let s_time=localStorage.getItem('s_time')||0;

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        //钱包地址
        address: null,
        //登录凭证
        _token: null,
        //蒙层
        showOverlay: false,
        //语言
        lang: null,
    },
    getters: {
        isLogin: state => {
            return state.address != null && state._token != null
        },
        token: state => {
            return state._token == null ? getToken() : state._token;
        }
    },
    mutations: {
        setAddress(state, address) {
            state.address = address
        },
        setToken(state, token) {
            state._token = token
            setToken(token);
        }
    },
    actions: {
        async login({ commit, state }) {
            let time=new Date().getTime()
            const interval = 2000;
            if (time - s_time < interval) {
                return
            }
            s_time=new Date().getTime()
            localStorage.setItem('s_time',s_time)
            //1.获取随机数
            const { data } = await generateNonce();
            const { uuid, nonce } = data

            //2.利用钱包进行签名
            const answer = await signMessage(nonce);

            //3.调用登录接口进行登录
            const ret = await requestLogin({
                "clientId": process.env.VUE_APP_CLIENT_ID,
                "grantType": "wallet",
                "uuid": uuid,
                "answer": answer,
                "address": state.address,
                "chainId": process.env.VUE_APP_CHAIN_ID
            });

            const accessToken = ret.data.access_token;
            commit('setToken', accessToken);
        },
        async getUserProfile({ commit }) {
            const { data } = await requestUserProfile();
            const address = data.user.wallet
            commit('setAddress', address);
        },
        async logout() {
            removeToken();
        }
    }
})
